<template>
    <div class="content">
        <Row type="flex" align="middle" class="code-row-bg mb16">
            <Col span="20">
                <Breadcrumb>
                    <Breadcrumb-item to="/">首页</Breadcrumb-item>
                    <Breadcrumb-item to="/my/customizedCCIC/order">我的订单</Breadcrumb-item>
                    <Breadcrumb-item>订单详情</Breadcrumb-item>
                </Breadcrumb>
            </Col>
            <Col span="4" class="right">
                <Button v-if="info.orderStatus=='UNPAID'" @click="cancelOrder" class="mr16">放弃投保</Button>
                <Button type="primary" v-if="info.orderStatus=='UNPAID'" @click="toPay">支付</Button>
            </Col>
            <!-- <Col span="2" v-if="info.paymentSource=='REVIEWING'">
                <Button type="primary" @click="updated">上传支付凭证</Button>
            </Col> -->
        </Row>
        <!-- 订单基本信息 -->
        <orderBasicInfo class="mb16" :info="info" type="order"/>
        <!-- 发票信息 -->
        <invoiceInfo v-if="info.invoiceInfo" :info="info.invoiceInfo" />
    </div>
    </template>
    <script>
    import orderBasicInfo from '../common/orderBasicInfo'
    import supportPlans from '../common/supportPlans'
    import riderInfo from '../common/riderInfo'
    import invoiceInfo from '../common/invoiceInfo'
    export default {
        components:{ 
            orderBasicInfo,
            supportPlans,
            riderInfo,
            invoiceInfo
        },
        data () {
            return {
                info:{},
                orderNo:this.$route.params.id,
                loading:false,
            }
        },
        mounted () {
            this.getInfo();
        },
        methods:{
            /*企业雇主责任险获取订单信息*/
            getInfo () {
                this.$axios.post('/broker/order/detail',{
                    orderNo: this.orderNo
                }).then(res=>{
                    this.info = res;
                });
            },
            // 上传支付凭证
            updated(){

            },
            //支付
            toPay(){
                sessionStorage.removeItem("track_session_key")
                window.location.href=`/common.html#/payCCIC?orderNo=${this.info.orderNo}&productCode=${this.info.productCode}`
            },
            // 取消
            cancelOrder(){
                this.$Modal.confirm({
                    title: '确认放弃投保吗？',
                    content: '点击确定按钮后，将取消投保订单',
                    onOk: () => {
                        this.$axios.post('/broker/order/close.all',{
                            orderNo: this.info.orderNo
                        }).then(res=>{
                            if(res.code==10000000){
                                this.$Message.success('操作成功')
                                this.getInfo()
                            }
                        })
                    },
                    onCancel: () => {
                        
                    }
                });
            },
            toAgin(){
                this.$Modal.confirm({
                    title: '确认此操作？',
                    onOk: () => {
                        // this.$axios.post('/broker/order/close.all',{
                        //     orderNo: this.info.orderNo
                        // }).then(res=>{
                        //     if(res.code==10000000){
                        //         this.$Message.success('操作成功')
                        //         this.getInfo()
                        //     }
                        // })
                    },
                    onCancel: () => {
                        
                    }
                });
            }
        }
    }
    </script>
<style lang="less" scoped>
    .content{
        width: 100%;
        height: 100%;
        padding: 15px;
        box-sizing: border-box;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/order/detail.vue